module.exports = __webpack_public_path__ + "static/img/15108175421.6b54e95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/15108175421.jpg
// module id = kMzn
// module chunks = 0